import { AddTag, Tag } from "../types/tag";
import axiosInstance from "./axiosConfig";

export const getTags = async () => {
    const response = await axiosInstance.get<Tag[]>('/tag');
    return response?.data;
};

export const getTag = async (id: string) => {
    const response = await axiosInstance.get<Tag>(`/tag/${id}`);
    return response?.data;
};

export const createTag = async (tag: AddTag) => {
    const response = await axiosInstance.post<Tag>('/tag', tag);
    return response?.data;
};

export const updateTag = async (id: string, tag: Tag) => {
    const response = await axiosInstance.patch<Tag>(`/tag/${id}`, tag);
    return response?.data;
}